import { render, staticRenderFns } from "./order_edit.vue?vue&type=template&id=513ec852&scoped=true&"
import script from "./order_edit.vue?vue&type=script&lang=js&"
export * from "./order_edit.vue?vue&type=script&lang=js&"
import style0 from "./order_edit.vue?vue&type=style&index=0&id=513ec852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ec852",
  null
  
)

export default component.exports